<div
  class="content"
  *ngIf="!wizardCtrl.wizardService.dataSaved && !wizardCtrl.wizardService.isLoading && !wizardCtrl.wizardService.requestFailed"
>
  <div class="stepContent" *ngIf="!isUploadEnabled">
    <div class="site-desc-container">
      <div class="header">
        <div class="title">Site definition</div>
        <div class="edit text-uppercase" (click)="wizardCtrl.goToStep('site_desc')">Edit</div>
      </div>
      <div class="site-desc">
        <div class="icon">
          <img src="{{siteImagePath}}" alt="image" />
        </div>
        <div class="desc-content">
          <div class="label">{{wizardCtrl.wizardService?.output?.name}}</div>
          <div class="description" *ngIf="wizardCtrl.wizardService?.output?.description">
            {{wizardCtrl.wizardService?.output?.description}}
          </div>
          <div class="location">
            <div class="city">{{wizardCtrl.wizardService?.output?.location?.city}}</div>
            <div class="country">{{wizardCtrl.wizardService?.output?.location?.country}}</div>
          </div>
          <!--Refer ATW-3745 - Commented the code since we should hide this for release version 2.0 -->
          <!-- <div class="tags" *ngIf="wizardCtrl.wizardService?.output?.tags">
            <div class="city">Tags:</div>
            <div class="label"
                 *ngFor="let tag of wizardCtrl.wizardService?.output?.tags; let $index = index;">{{tag}}
              <span *ngIf="$index < (wizardCtrl.wizardService?.output?.tags?.length-1)">, </span>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <ng-container *ngIf="wizardCtrl.wizardService?.output?.subnets != null">
      <div class="subnet-defs-container" *ngIf="wizardCtrl.wizardService?.output?.subnets.length">
        <div class="header">
          <div class="title">Subnet definition</div>
        </div>
        <div class="subnet-defs">
          <div class="icon">
            <img src="images/subnets.svg" alt="subnets" />
          </div>
          <div class="list">
            <div class="subnet-header">
              <div class="subnet-header-wrapper">
                <div class="subnet-name">
                  <div class="subnet-name-label">Subnet name</div>
                </div>
                <div class="subnet-range">
                  <div class="subnet-range-label">Subnet range</div>
                </div>
                <div></div>
              </div>
            </div>
            <div class="subnet-list">
              <div class="subnet" *ngFor="let subnet of wizardCtrl.wizardService?.output?.subnets">
                <div class="subnet-name">
                  <div class="subnet-name-label">{{subnet.name}}</div>
                </div>
                <div class="subnet-range">{{subnet.subnet}}</div>
                <div class="subnet-action"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div *ngIf="wizardCtrl.getWizardService().isLoading" class="flex-centered">
  <div class="label medium-margin">
    <p>Creating {{ step.parent.output.name }} site</p>
  </div>
  <mat-spinner></mat-spinner>
  <div class="label medium-margin">One moment...</div>
</div>

<div class="bulk-site-location-container" *ngIf="isUploadEnabled">
  <div class="site-header">
    <div class="icon-container">
      <img class="icon" src="{{siteImagePath}}" alt="Site image" />
    </div>
    <div class="site-title">
      <span class="site-title__main"
        >{{wizardService.formattedSiteData.length}} Sites will be imported</span
      >
      <span class="site-title__sub">No errors</span>
    </div>
  </div>
  <div class="site-content">
    <div class="site-location-list">
      <div class="list-head">
        <div class="site-head-cell">Site</div>
        <div class="site-head-cell">Location</div>
      </div>
      <div class="list-body">
        <div
          *ngFor="let row; let item of wizardService.formattedSiteData; let i = index"
          class="list-item"
          [ngClass]="{highlighted: step.selectedRowIndex == i }"
          (click)="step.selectTypeContent('uploadSiteDetails', item); step.selectedRowIndex=i;"
        >
          <div class="site">{{item.name}}</div>
          <ng-container *ngIf="item.location.country">
            <div class="location">{{item.location.country}},{{item.location.state}}</div>
          </ng-container>
          <ng-container *ngIf="!item.location.country">
            <div class="location">{{item.location.location}}</div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
